import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListItemStatusRequest extends IBaseRequest {
    id?: number;
    systemId?: number;
}

export class ListItemStatusRequest extends BaseRequest implements IListItemStatusRequest {
  public id?: number;
  public systemId?: number;

  constructor(server: string, session: string, id?: number, systemId?: number) {
    super(server, session);
    this.id = id;
    this.systemId = systemId;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.systemId, 'systemId');

    return super.wrapperXml('ListItemStatus', parameters);
  }
}
